import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators } from "../redux/productSalesSagas";
import MultiSelectDropdown from "../../../../components/multiSelectDropdown/multiSelectDropdown";

const PeriodType = () => {
  const dispatch = useDispatch();

  const periodTypeOptions = useSelector((state) => state.productSales.periodTypeOptions);
  const selectedPeriodType = useSelector((state) => state.productSales.selectedFilters.period_type);

  return (
    <MultiSelectDropdown
      options={periodTypeOptions}
      selectedFilters={selectedPeriodType}
      includeFilter={false}
      onSelectChange={(data) => dispatch(actionCreators.updatePeriodType(data))}
    />
  );
};
export default PeriodType;
